var _rect, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5421,
    y: 14,
    width: 16,
    height: 14,
    rx: 2.8,
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3554 19.3329L16.9961 23.2974C16.7736 23.9464 17.2559 24.6217 17.9421 24.6217H26.6102C27.4214 24.6217 27.895 23.7067 27.4267 23.0443L25.6477 20.5287C25.2829 20.0128 24.5371 19.9603 24.1037 20.42L23.3277 21.2431C22.9121 21.6838 22.2031 21.6568 21.8223 21.1856L20.0791 19.0286C19.5848 18.417 18.6105 18.5889 18.3554 19.3329Z",
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.542,
    cy: 17.6217,
    r: 1,
    fill: "#C78817"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 31,
    r: 1,
    fill: "#C78817"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 31,
    r: 1,
    fill: "#C78817"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 31,
    r: 1,
    fill: "#C78817"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9306 26.4732L14.6307 26.4732L14.6308 16.2475L13.9305 16.2475C12.3841 16.2475 11.1307 17.5011 11.1307 19.0475L11.1306 23.6732C11.1306 25.2196 12.3842 26.4732 13.9306 26.4732Z",
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3309 26.4732L30.6308 26.4732L30.6307 16.2475L31.3308 16.2475C32.8772 16.2475 34.1308 17.5011 34.1308 19.0475L34.1308 23.6732C34.1309 25.2196 32.8773 26.4732 31.3309 26.4732Z",
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.ca1c850514eea2f9c32c727480fee0f1.svg";
export { ForwardRef as ReactComponent };